import styled from 'styled-components';
import { TagContainerProps } from './types';
import { TVariant } from '../basicCard/types';
import { MAIN_COLOR, SECONDARY_BG_COLOR, TEXT_COLOR } from 'shared/consts';
import { getContrastColor } from 'shared/lib/colors';

const getVariantStyles = (variant: TVariant | undefined) => {
	switch (variant) {
		case 'main':
			return {
				background: MAIN_COLOR,
				color: 'white',
			};
		case 'secondary':
			return {
				background: SECONDARY_BG_COLOR,
				color: 'black',
			};
		case 'default':
			return {
				background: 'white',
				color: TEXT_COLOR,
			};
		default:
			return {
				background: 'white',
				color: TEXT_COLOR,
			};
	}
};

export const TagContainer = styled.div<TagContainerProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3px 2.5px;
	gap: 8px;
  font-size: 12px;
  min-width: 21px;

	border-radius: calc(1px / 0);

  ${props => {
    if (props.$bg) {
      return `
        background: ${props.$bg};
        color: ${getContrastColor(props.$bg)};
      `
    }

    return `
      background: ${getVariantStyles(props.$variant).background};
      color: ${getVariantStyles(props.$variant).color};
    `
  }}
`;
